import { gql } from "@apollo/client";
export const regionsQuery = gql`
    query Regions {
        modelSpecifications {
            nodes {
                id
                name
            }
        }
    }
`;
